import { render } from "./ContentSetoran.vue?vue&type=template&id=21b4a273&scoped=true"
import script from "./ContentSetoran.vue?vue&type=script&lang=js"
export * from "./ContentSetoran.vue?vue&type=script&lang=js"

import "./ContentSetoran.vue?vue&type=style&index=0&id=21b4a273&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b4a273"]])

export default __exports__